var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiskusNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 254.997,
    height: 80,
    viewBox: "0 0 254.997 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cebb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ba5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-10.002 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(105.678 21.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1329.184,474.972V439.727a.709.709,0,0,1,.709-.709h12.614a19.918,19.918,0,0,1,7.875,1.446,15.831,15.831,0,0,1,9.063,9.734,21.863,21.863,0,0,1,1.136,7.1,21.463,21.463,0,0,1-1.265,7.565,16.16,16.16,0,0,1-3.64,5.784,16.4,16.4,0,0,1-5.706,3.718,20.145,20.145,0,0,1-7.462,1.317h-12.614A.709.709,0,0,1,1329.184,474.972ZM1353.4,457.3a15.613,15.613,0,0,0-.723-4.854,10.878,10.878,0,0,0-2.117-3.821,9.44,9.44,0,0,0-3.434-2.479,11.6,11.6,0,0,0-4.622-.878h-5.478a.718.718,0,0,0-.718.718v22.73a.718.718,0,0,0,.718.718h5.478a11.16,11.16,0,0,0,4.673-.93,9.57,9.57,0,0,0,3.408-2.556,11.388,11.388,0,0,0,2.092-3.847A15.431,15.431,0,0,0,1353.4,457.3Z",
    transform: "translate(-1329.184 -439.018)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 6.92,
    height: 6.868,
    rx: 3.434,
    transform: "translate(36.302 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 6.92,
    height: 27.059,
    rx: 3.46,
    transform: "translate(36.302 9.605)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1673.437,526.856a20.933,20.933,0,0,1-6.661-1.084,16.5,16.5,0,0,1-5.1-2.7.709.709,0,0,1-.166-.918l1.884-3.165a.71.71,0,0,1,1.007-.224,21.4,21.4,0,0,0,4.209,2.233,12.935,12.935,0,0,0,4.673.9,5.909,5.909,0,0,0,3.253-.775,2.5,2.5,0,0,0,1.188-2.22,2.219,2.219,0,0,0-1.394-2.117,30.261,30.261,0,0,0-4.544-1.549q-2.633-.722-4.493-1.394a11.506,11.506,0,0,1-3-1.523,5.2,5.2,0,0,1-1.652-1.962,6.26,6.26,0,0,1-.517-2.659,8.418,8.418,0,0,1,.8-3.718,8.1,8.1,0,0,1,2.246-2.814,10.4,10.4,0,0,1,3.382-1.781,13.74,13.74,0,0,1,4.209-.62,18.108,18.108,0,0,1,5.706.878,13.777,13.777,0,0,1,4.39,2.425.709.709,0,0,1,.139.942l-2.032,3.048a.705.705,0,0,1-.993.183,15.467,15.467,0,0,0-3.414-1.846,10.95,10.95,0,0,0-3.847-.723,5.569,5.569,0,0,0-2.943.723,2.515,2.515,0,0,0-1.188,2.324,2.245,2.245,0,0,0,.284,1.188,2.492,2.492,0,0,0,.9.826,8.765,8.765,0,0,0,1.627.7q1.007.337,2.5.7,2.788.724,4.777,1.446a13.043,13.043,0,0,1,3.253,1.652,5.9,5.9,0,0,1,1.859,2.143,6.592,6.592,0,0,1,.594,2.918,7.529,7.529,0,0,1-2.943,6.274A12.681,12.681,0,0,1,1673.437,526.856Z",
    transform: "translate(-1613.743 -490.192)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1871.132,475.365l-7.157-10.689a.716.716,0,0,0-1.1-.111l-2.847,2.807a.857.857,0,0,0-.255.61v6.988a.709.709,0,0,1-.709.709h-5.5a.709.709,0,0,1-.709-.709V439.725a.709.709,0,0,1,.709-.709h5.5a.709.709,0,0,1,.709.709v19.259a.714.714,0,0,0,1.247.474l9.386-10.548a.708.708,0,0,1,.53-.238h5.5a.709.709,0,0,1,.533,1.177l-8.666,9.866a.716.716,0,0,0-.05.88l9.7,13.97a.709.709,0,0,1-.582,1.114h-5.65A.709.709,0,0,1,1871.132,475.365Z",
    transform: "translate(-1777.723 -439.016)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M2291.527,526.856a20.934,20.934,0,0,1-6.662-1.084,16.507,16.507,0,0,1-5.1-2.7.709.709,0,0,1-.166-.918l1.884-3.165a.71.71,0,0,1,1.006-.224,21.4,21.4,0,0,0,4.209,2.233,12.935,12.935,0,0,0,4.673.9,5.907,5.907,0,0,0,3.253-.775,2.5,2.5,0,0,0,1.188-2.22,2.219,2.219,0,0,0-1.394-2.117,30.263,30.263,0,0,0-4.544-1.549q-2.634-.722-4.493-1.394a11.506,11.506,0,0,1-3-1.523,5.2,5.2,0,0,1-1.652-1.962,6.257,6.257,0,0,1-.517-2.659,8.418,8.418,0,0,1,.8-3.718,8.1,8.1,0,0,1,2.246-2.814,10.394,10.394,0,0,1,3.382-1.781,13.74,13.74,0,0,1,4.208-.62,18.109,18.109,0,0,1,5.706.878,13.777,13.777,0,0,1,4.389,2.425.709.709,0,0,1,.139.942l-2.032,3.048a.705.705,0,0,1-.993.183,15.466,15.466,0,0,0-3.415-1.846,10.949,10.949,0,0,0-3.847-.723,5.569,5.569,0,0,0-2.943.723,2.515,2.515,0,0,0-1.188,2.324,2.243,2.243,0,0,0,.284,1.188,2.49,2.49,0,0,0,.9.826,8.769,8.769,0,0,0,1.626.7q1.007.337,2.5.7,2.788.724,4.776,1.446a13.046,13.046,0,0,1,3.253,1.652,5.891,5.891,0,0,1,1.859,2.143,6.589,6.589,0,0,1,.594,2.918,7.528,7.528,0,0,1-2.943,6.274A12.679,12.679,0,0,1,2291.527,526.856Z",
    transform: "translate(-2143.153 -490.192)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2071.385,529.943a7.683,7.683,0,0,1-6.352-2.685q-2.169-2.684-2.169-7.952v-16.23a.707.707,0,0,1,.708-.707h5.5a.707.707,0,0,1,.707.707v14.733q0,6.249,4.493,6.248a7.106,7.106,0,0,0,3.9-1.214,8.629,8.629,0,0,0,3-3.542.711.711,0,0,0,.073-.316V503.076a.707.707,0,0,1,.708-.707h5.5a.708.708,0,0,1,.708.707v18.4a2.431,2.431,0,0,0,.387,1.549,1.383,1.383,0,0,0,.734.436.7.7,0,0,1,.531.67v4.709a.708.708,0,0,1-.587.7q-.654.112-1.143.149-.7.051-1.265.052a4.984,4.984,0,0,1-3.021-.852,3.353,3.353,0,0,1-1.368-2.349l-.021-.29a.706.706,0,0,0-1.231-.422,11.288,11.288,0,0,1-3.55,2.726A13.984,13.984,0,0,1,2071.385,529.943Z",
    transform: "translate(-1957.6 -493.279)",
    fill: "#5a5a5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M19417.447,18902c.035-.039.068-.078.1-.117a6.04,6.04,0,0,0-.1-7.752h3.59a32.019,32.019,0,0,0,20.889-8.072c.078-.068.152-.137.23-.211h0a3.958,3.958,0,0,1,5.318,5.852h0c-.113.107-.23.205-.342.309-.846.742-1.715,1.449-2.619,2.123a39.8,39.8,0,0,1-23.32,7.869Zm-10.68-3.932a3.934,3.934,0,1,1,3.936,3.932A3.934,3.934,0,0,1,19406.768,18898.07Zm-18.277-9.988c.107-.127.211-.258.309-.391a5.517,5.517,0,0,0,.512-.854c.045-.078.078-.162.117-.244a6.069,6.069,0,0,0-.629-5.988c-.1-.137-.2-.264-.309-.391v-.006h32.205a18.207,18.207,0,1,0,0-36.414h-23.668a3.935,3.935,0,1,1,0-7.869h24.494a26.091,26.091,0,0,1-.049,52.156Zm-10.988-3.936a3.934,3.934,0,1,1,3.932,3.936A3.934,3.934,0,0,1,19377.5,18884.146Zm71.629-6.395a4.022,4.022,0,0,1,.273-1.455c.092-.176.18-.361.268-.547a32.149,32.149,0,0,0-9.543-39.277l-.732-.547a31.979,31.979,0,0,0-18.773-6.051h-13.07a3.992,3.992,0,0,1-4.02-3.824,3.939,3.939,0,0,1,3.938-4.049h13.2a40.022,40.022,0,0,1,36.141,57.178c-.1.205-.2.4-.3.609a3.974,3.974,0,0,1-7.385-2.037Z",
    transform: "translate(-19377.5 -18822.002)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskusNewLogo);
export default __webpack_public_path__ + "static/media/Diskus_newLogo.811ad46dc44c89d70877596a95f8f3d3.svg";
export { ForwardRef as ReactComponent };